import { $fetch } from '@/boot/fetch'
import { replacePathTokens } from '@/utils/routes.util'

const ENDPOINT = '/retailers/{{retailerId}}/addresses'

export default {
  /**
   * Add an address for the retailer
   * @param {String} retailerId - The retailer ID
   * @param {Object} body - Address body
   * @return {Promise}
   */
  addSingle(retailerId, body) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }), {
      method: 'POST',
      body,
    })
  },

  /**
   * Update an address for the retailer
   * @param {String} retailerId - The retailer ID
   * @param {String} addressId - The address ID
   * @param {Object} body - Address body
   * @return {Promise}
   */
  updateSingle(retailerId, addressId, body) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }) + `/${addressId}`, {
      method: 'PUT',
      body,
    })
  },

  /**
   * Delete an address for the retailer
   * @param {String} retailerId - The retailer ID
   * @param {String} addressId - The address ID
   * @return {Promise}
   */
  deleteSingle(retailerId, addressId) {
    return $fetch.peg(replacePathTokens(ENDPOINT, { retailerId }) + `/${addressId}`, {
      method: 'DELETE',
    })
  },
}
